import { HttpResult } from "widgets-for-react"
import { ParsedOverviewDetailItem } from "../customPages/overviewPage/widgets/overviewWidget.state"
import { loadOverviewItems } from "../customPages/overviewPage/widgets/overviewWidget.api"

export const loadSearchSuggestion = async (searchValue: string): Promise<HttpResult<Immutable.List<ParsedOverviewDetailItem>>> => {
  const res = await loadOverviewItems("search", 5, [{ key: "searchQuery", value: searchValue }], 'block')
  if (res.kind != "result") return res

  let paginatedData = res.value
  paginatedData = {
    ...paginatedData,
    items:paginatedData.items
      .filter(i => i.Link?.url != window.location.pathname)
      .take(5)
  }
  return {
    kind: 'result',
    status: 200,
    value: paginatedData.items
  }
}
